import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'platform-integrations-api.vendasta-local.com',
  'test': '',
  'demo': 'platform-integrations-demo.apigateway.co',
  'prod': 'platform-integrations-prod.apigateway.co',
  'production': 'platform-integrations-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var ActionType = /*#__PURE__*/function (ActionType) {
  ActionType[ActionType["ACTION_TYPE_UNSPECIFIED"] = 0] = "ACTION_TYPE_UNSPECIFIED";
  ActionType[ActionType["ACTION_TYPE_CONTINUE"] = 1] = "ACTION_TYPE_CONTINUE";
  ActionType[ActionType["ACTION_TYPE_CANCEL"] = 2] = "ACTION_TYPE_CANCEL";
  ActionType[ActionType["ACTION_TYPE_ADD_CONNECTION"] = 3] = "ACTION_TYPE_ADD_CONNECTION";
  ActionType[ActionType["ACTION_TYPE_SEND_REQUEST"] = 4] = "ACTION_TYPE_SEND_REQUEST";
  ActionType[ActionType["ACTION_TYPE_COPY"] = 5] = "ACTION_TYPE_COPY";
  ActionType[ActionType["ACTION_TYPE_SAVE"] = 6] = "ACTION_TYPE_SAVE";
  ActionType[ActionType["ACTION_TYPE_UNLOCK"] = 7] = "ACTION_TYPE_UNLOCK";
  ActionType[ActionType["ACTION_TYPE_EDIT"] = 8] = "ACTION_TYPE_EDIT";
  return ActionType;
}(ActionType || {});
var ConnectionMethods = /*#__PURE__*/function (ConnectionMethods) {
  ConnectionMethods[ConnectionMethods["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  ConnectionMethods[ConnectionMethods["OAUTH2"] = 1] = "OAUTH2";
  ConnectionMethods[ConnectionMethods["APIKEY"] = 2] = "APIKEY";
  ConnectionMethods[ConnectionMethods["VENDOR_MANAGED"] = 3] = "VENDOR_MANAGED";
  ConnectionMethods[ConnectionMethods["LEGACY_OAUTH"] = 4] = "LEGACY_OAUTH";
  return ConnectionMethods;
}(ConnectionMethods || {});
var ConnectionStatus = /*#__PURE__*/function (ConnectionStatus) {
  ConnectionStatus[ConnectionStatus["UNSPECIFIED_STATUS"] = 0] = "UNSPECIFIED_STATUS";
  ConnectionStatus[ConnectionStatus["PRECONNECTED"] = 1] = "PRECONNECTED";
  ConnectionStatus[ConnectionStatus["CONNECTED"] = 2] = "CONNECTED";
  ConnectionStatus[ConnectionStatus["DISCONNECTED"] = 3] = "DISCONNECTED";
  ConnectionStatus[ConnectionStatus["DELETED"] = 4] = "DELETED";
  return ConnectionStatus;
}(ConnectionStatus || {});
var FieldScope = /*#__PURE__*/function (FieldScope) {
  FieldScope[FieldScope["INTEGRATION_SUPPORT"] = 0] = "INTEGRATION_SUPPORT";
  FieldScope[FieldScope["NAMESPACE_ADMINS"] = 1] = "NAMESPACE_ADMINS";
  FieldScope[FieldScope["CONNECTING_USER"] = 2] = "CONNECTING_USER";
  return FieldScope;
}(FieldScope || {});
var FieldType = /*#__PURE__*/function (FieldType) {
  FieldType[FieldType["FIELD_TYPE_UNSPECIFIED"] = 0] = "FIELD_TYPE_UNSPECIFIED";
  FieldType[FieldType["FIELD_TYPE_CHECKBOX"] = 1] = "FIELD_TYPE_CHECKBOX";
  FieldType[FieldType["FIELD_TYPE_TOGGLE"] = 2] = "FIELD_TYPE_TOGGLE";
  FieldType[FieldType["FIELD_TYPE_PASSWORD"] = 3] = "FIELD_TYPE_PASSWORD";
  FieldType[FieldType["FIELD_TYPE_TEXT"] = 4] = "FIELD_TYPE_TEXT";
  FieldType[FieldType["FIELD_TYPE_RADIO"] = 5] = "FIELD_TYPE_RADIO";
  FieldType[FieldType["FIELD_TYPE_SELECT"] = 6] = "FIELD_TYPE_SELECT";
  FieldType[FieldType["FIELD_TYPE_LABEL"] = 7] = "FIELD_TYPE_LABEL";
  FieldType[FieldType["FIELD_TYPE_CHIPLIST"] = 8] = "FIELD_TYPE_CHIPLIST";
  FieldType[FieldType["FIELD_TYPE_URL"] = 9] = "FIELD_TYPE_URL";
  return FieldType;
}(FieldType || {});
var HTTPMethod = /*#__PURE__*/function (HTTPMethod) {
  HTTPMethod[HTTPMethod["UNDEFINED"] = 0] = "UNDEFINED";
  HTTPMethod[HTTPMethod["POST"] = 1] = "POST";
  HTTPMethod[HTTPMethod["GET"] = 2] = "GET";
  HTTPMethod[HTTPMethod["PUT"] = 3] = "PUT";
  HTTPMethod[HTTPMethod["DELETE"] = 4] = "DELETE";
  HTTPMethod[HTTPMethod["PATCH"] = 5] = "PATCH";
  return HTTPMethod;
}(HTTPMethod || {});
var Severity = /*#__PURE__*/function (Severity) {
  Severity[Severity["UNSPECIFIED_SEVERITY"] = 0] = "UNSPECIFIED_SEVERITY";
  Severity[Severity["INFO"] = 1] = "INFO";
  Severity[Severity["WARNING"] = 2] = "WARNING";
  Severity[Severity["ERROR"] = 3] = "ERROR";
  return Severity;
}(Severity || {});
var SupportedContexts = /*#__PURE__*/function (SupportedContexts) {
  SupportedContexts[SupportedContexts["PI_CONTEXT_UNSET"] = 0] = "PI_CONTEXT_UNSET";
  SupportedContexts[SupportedContexts["PI_CONTEXT_PARTNER"] = 1] = "PI_CONTEXT_PARTNER";
  SupportedContexts[SupportedContexts["PI_CONTEXT_SMB"] = 2] = "PI_CONTEXT_SMB";
  return SupportedContexts;
}(SupportedContexts || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class APIRequest {
  static fromProto(proto) {
    let m = new APIRequest();
    m = Object.assign(m, proto);
    if (proto.method) {
      m.method = enumStringToValue$3(HTTPMethod, proto.method);
    }
    if (proto.query) {
      m.query = proto.query.map(HTTPParam.fromProto);
    }
    if (proto.headers) {
      m.headers = proto.headers.map(HTTPParam.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.method !== 'undefined') {
      toReturn['method'] = this.method;
    }
    if (typeof this.path !== 'undefined') {
      toReturn['path'] = this.path;
    }
    if (typeof this.query !== 'undefined' && this.query !== null) {
      toReturn['query'] = 'toApiJson' in this.query ? this.query.toApiJson() : this.query;
    }
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    return toReturn;
  }
}
class APIResponse {
  static fromProto(proto) {
    let m = new APIResponse();
    m = Object.assign(m, proto);
    if (proto.headers) {
      m.headers = proto.headers.map(HTTPParam.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.headers !== 'undefined' && this.headers !== null) {
      toReturn['headers'] = 'toApiJson' in this.headers ? this.headers.toApiJson() : this.headers;
    }
    if (typeof this.statusCode !== 'undefined') {
      toReturn['statusCode'] = this.statusCode;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    return toReturn;
  }
}
class Actions {
  static fromProto(proto) {
    let m = new Actions();
    m = Object.assign(m, proto);
    if (proto.actionType) {
      m.actionType = enumStringToValue$3(ActionType, proto.actionType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.actionType !== 'undefined') {
      toReturn['actionType'] = this.actionType;
    }
    return toReturn;
  }
}
class AdditionalInfo {
  static fromProto(proto) {
    let m = new AdditionalInfo();
    m = Object.assign(m, proto);
    if (proto.websites) {
      m.websites = proto.websites.map(WebsiteInfo.fromProto);
    }
    if (proto.resources) {
      m.resources = proto.resources.map(ResourceInfo.fromProto);
    }
    if (proto.worksWith) {
      m.worksWith = proto.worksWith.map(FieldConfig.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.provider !== 'undefined') {
      toReturn['provider'] = this.provider;
    }
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    if (typeof this.websites !== 'undefined' && this.websites !== null) {
      toReturn['websites'] = 'toApiJson' in this.websites ? this.websites.toApiJson() : this.websites;
    }
    if (typeof this.requirements !== 'undefined') {
      toReturn['requirements'] = this.requirements;
    }
    if (typeof this.resources !== 'undefined' && this.resources !== null) {
      toReturn['resources'] = 'toApiJson' in this.resources ? this.resources.toApiJson() : this.resources;
    }
    if (typeof this.businesses !== 'undefined') {
      toReturn['businesses'] = this.businesses;
    }
    if (typeof this.billing !== 'undefined') {
      toReturn['billing'] = this.billing;
    }
    if (typeof this.productIds !== 'undefined') {
      toReturn['productIds'] = this.productIds;
    }
    if (typeof this.worksWith !== 'undefined' && this.worksWith !== null) {
      toReturn['worksWith'] = 'toApiJson' in this.worksWith ? this.worksWith.toApiJson() : this.worksWith;
    }
    return toReturn;
  }
}
class CallIntegrationEndpointRequest {
  static fromProto(proto) {
    let m = new CallIntegrationEndpointRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = ConnectionIdentifier.fromProto(proto.connection);
    }
    if (proto.request) {
      m.request = APIRequest.fromProto(proto.request);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.request !== 'undefined' && this.request !== null) {
      toReturn['request'] = 'toApiJson' in this.request ? this.request.toApiJson() : this.request;
    }
    return toReturn;
  }
}
class CallIntegrationEndpointResponse {
  static fromProto(proto) {
    let m = new CallIntegrationEndpointResponse();
    m = Object.assign(m, proto);
    if (proto.response) {
      m.response = APIResponse.fromProto(proto.response);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.response !== 'undefined' && this.response !== null) {
      toReturn['response'] = 'toApiJson' in this.response ? this.response.toApiJson() : this.response;
    }
    if (typeof this.requestId !== 'undefined') {
      toReturn['requestId'] = this.requestId;
    }
    return toReturn;
  }
}
class CallVendastaEndpointRequest {
  static fromProto(proto) {
    let m = new CallVendastaEndpointRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = ConnectionIdentifier.fromProto(proto.connection);
    }
    if (proto.request) {
      m.request = APIRequest.fromProto(proto.request);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.request !== 'undefined' && this.request !== null) {
      toReturn['request'] = 'toApiJson' in this.request ? this.request.toApiJson() : this.request;
    }
    return toReturn;
  }
}
class CallVendastaEndpointResponse {
  static fromProto(proto) {
    let m = new CallVendastaEndpointResponse();
    m = Object.assign(m, proto);
    if (proto.response) {
      m.response = APIResponse.fromProto(proto.response);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.response !== 'undefined' && this.response !== null) {
      toReturn['response'] = 'toApiJson' in this.response ? this.response.toApiJson() : this.response;
    }
    if (typeof this.requestId !== 'undefined') {
      toReturn['requestId'] = this.requestId;
    }
    return toReturn;
  }
}
class ConnectionIdentifier {
  static fromProto(proto) {
    let m = new ConnectionIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class ConnectionMessage {
  static fromProto(proto) {
    let m = new ConnectionMessage();
    m = Object.assign(m, proto);
    if (proto.severity) {
      m.severity = enumStringToValue$3(Severity, proto.severity);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.severity !== 'undefined') {
      toReturn['severity'] = this.severity;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.message !== 'undefined') {
      toReturn['message'] = this.message;
    }
    if (typeof this.ctaText !== 'undefined') {
      toReturn['ctaText'] = this.ctaText;
    }
    if (typeof this.ctaUrl !== 'undefined') {
      toReturn['ctaUrl'] = this.ctaUrl;
    }
    return toReturn;
  }
}
class ConnectionResponse {
  static fromProto(proto) {
    let m = new ConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.status) {
      m.status = enumStringToValue$3(ConnectionStatus, proto.status);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.statusLastUpdated) {
      m.statusLastUpdated = new Date(proto.statusLastUpdated);
    }
    if (proto.dataLastReceived) {
      m.dataLastReceived = new Date(proto.dataLastReceived);
    }
    if (proto.context) {
      m.context = enumStringToValue$3(SupportedContexts, proto.context);
    }
    if (proto.connectionMessages) {
      m.connectionMessages = proto.connectionMessages.map(ConnectionMessage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.statusLastUpdated !== 'undefined' && this.statusLastUpdated !== null) {
      toReturn['statusLastUpdated'] = 'toApiJson' in this.statusLastUpdated ? this.statusLastUpdated.toApiJson() : this.statusLastUpdated;
    }
    if (typeof this.dataLastReceived !== 'undefined' && this.dataLastReceived !== null) {
      toReturn['dataLastReceived'] = 'toApiJson' in this.dataLastReceived ? this.dataLastReceived.toApiJson() : this.dataLastReceived;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.connectionMessages !== 'undefined' && this.connectionMessages !== null) {
      toReturn['connectionMessages'] = 'toApiJson' in this.connectionMessages ? this.connectionMessages.toApiJson() : this.connectionMessages;
    }
    return toReturn;
  }
}
class CreateConnectionRequest {
  static fromProto(proto) {
    let m = new CreateConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.context) {
      m.context = enumStringToValue$3(SupportedContexts, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class CreateConnectionResponse {
  static fromProto(proto) {
    let m = new CreateConnectionResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    return toReturn;
  }
}
class CreateIntegrationRequest {
  static fromProto(proto) {
    let m = new CreateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$3(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$3(SupportedContexts, v));
    }
    if (proto.preconnectFormFields) {
      m.preconnectFormFields = FormConfig.fromProto(proto.preconnectFormFields);
    }
    if (proto.configPageFields) {
      m.configPageFields = proto.configPageFields.map(FormConfig.fromProto);
    }
    if (proto.instructions) {
      m.instructions = FormConfig.fromProto(proto.instructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.authenticationUrl !== 'undefined') {
      toReturn['authenticationUrl'] = this.authenticationUrl;
    }
    if (typeof this.tokenUrl !== 'undefined') {
      toReturn['tokenUrl'] = this.tokenUrl;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.webhookVerifierToken !== 'undefined') {
      toReturn['webhookVerifierToken'] = this.webhookVerifierToken;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    if (typeof this.fieldExtensionIds !== 'undefined') {
      toReturn['fieldExtensionIds'] = this.fieldExtensionIds;
    }
    if (typeof this.preconnectFormFields !== 'undefined' && this.preconnectFormFields !== null) {
      toReturn['preconnectFormFields'] = 'toApiJson' in this.preconnectFormFields ? this.preconnectFormFields.toApiJson() : this.preconnectFormFields;
    }
    if (typeof this.configPageFields !== 'undefined' && this.configPageFields !== null) {
      toReturn['configPageFields'] = 'toApiJson' in this.configPageFields ? this.configPageFields.toApiJson() : this.configPageFields;
    }
    if (typeof this.instructions !== 'undefined' && this.instructions !== null) {
      toReturn['instructions'] = 'toApiJson' in this.instructions ? this.instructions.toApiJson() : this.instructions;
    }
    return toReturn;
  }
}
class CreateIntegrationResponse {
  static fromProto(proto) {
    let m = new CreateIntegrationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class CustomFields {
  static fromProto(proto) {
    let m = new CustomFields();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DeleteConnectionRequest {
  static fromProto(proto) {
    let m = new DeleteConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class DeleteIntegrationRequest {
  static fromProto(proto) {
    let m = new DeleteIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class EmitEventRequest {
  static fromProto(proto) {
    let m = new EmitEventRequest();
    m = Object.assign(m, proto);
    if (proto.emittedAt) {
      m.emittedAt = new Date(proto.emittedAt);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.topic !== 'undefined') {
      toReturn['topic'] = this.topic;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.payload !== 'undefined') {
      toReturn['payload'] = this.payload;
    }
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    if (typeof this.emittedAt !== 'undefined' && this.emittedAt !== null) {
      toReturn['emittedAt'] = 'toApiJson' in this.emittedAt ? this.emittedAt.toApiJson() : this.emittedAt;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    return toReturn;
  }
}
class EmitEventResponse {
  static fromProto(proto) {
    let m = new EmitEventResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.eventId !== 'undefined') {
      toReturn['eventId'] = this.eventId;
    }
    return toReturn;
  }
}
class FieldConfig {
  static fromProto(proto) {
    let m = new FieldConfig();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$3(FieldType, proto.fieldType);
    }
    if (proto.dependents) {
      m.dependents = proto.dependents.map(FieldConfig.fromProto);
    }
    if (proto.options) {
      m.options = proto.options.map(FieldOptions.fromProto);
    }
    if (proto.actions) {
      m.actions = proto.actions.map(Actions.fromProto);
    }
    if (proto.fieldScopes) {
      m.fieldScopes = proto.fieldScopes.map(v => enumStringToValue$3(FieldScope, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.id !== 'undefined') {
      toReturn['id'] = this.id;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.placeHolder !== 'undefined') {
      toReturn['placeHolder'] = this.placeHolder;
    }
    if (typeof this.hintText !== 'undefined') {
      toReturn['hintText'] = this.hintText;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.required !== 'undefined') {
      toReturn['required'] = this.required;
    }
    if (typeof this.dependents !== 'undefined' && this.dependents !== null) {
      toReturn['dependents'] = 'toApiJson' in this.dependents ? this.dependents.toApiJson() : this.dependents;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    if (typeof this.actions !== 'undefined' && this.actions !== null) {
      toReturn['actions'] = 'toApiJson' in this.actions ? this.actions.toApiJson() : this.actions;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.icon !== 'undefined') {
      toReturn['icon'] = this.icon;
    }
    if (typeof this.defaultValue !== 'undefined') {
      toReturn['defaultValue'] = this.defaultValue;
    }
    if (typeof this.hidden !== 'undefined') {
      toReturn['hidden'] = this.hidden;
    }
    if (typeof this.fieldScopes !== 'undefined') {
      toReturn['fieldScopes'] = this.fieldScopes;
    }
    if (typeof this.readonly !== 'undefined') {
      toReturn['readonly'] = this.readonly;
    }
    return toReturn;
  }
}
class FieldOptions {
  static fromProto(proto) {
    let m = new FieldOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ListConnectionRequestFilters {
  static fromProto(proto) {
    let m = new ListConnectionRequestFilters();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue$3(SupportedContexts, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class GetConnectionRequestFilters {
  static fromProto(proto) {
    let m = new GetConnectionRequestFilters();
    m = Object.assign(m, proto);
    if (proto.context) {
      m.context = enumStringToValue$3(SupportedContexts, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class FormConfig {
  static fromProto(proto) {
    let m = new FormConfig();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(FieldConfig.fromProto);
    }
    if (proto.actions) {
      m.actions = proto.actions.map(Actions.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.fields !== 'undefined' && this.fields !== null) {
      toReturn['fields'] = 'toApiJson' in this.fields ? this.fields.toApiJson() : this.fields;
    }
    if (typeof this.actions !== 'undefined' && this.actions !== null) {
      toReturn['actions'] = 'toApiJson' in this.actions ? this.actions.toApiJson() : this.actions;
    }
    return toReturn;
  }
}
class GetConnectionDataRequest {
  static fromProto(proto) {
    let m = new GetConnectionDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    return toReturn;
  }
}
class GetConnectionDataResponse {
  static fromProto(proto) {
    let m = new GetConnectionDataResponse();
    m = Object.assign(m, proto);
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.status) {
      m.status = enumStringToValue$3(ConnectionStatus, proto.status);
    }
    if (proto.statusLastUpdated) {
      m.statusLastUpdated = new Date(proto.statusLastUpdated);
    }
    if (proto.dataLastReceived) {
      m.dataLastReceived = new Date(proto.dataLastReceived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.statusLastUpdated !== 'undefined' && this.statusLastUpdated !== null) {
      toReturn['statusLastUpdated'] = 'toApiJson' in this.statusLastUpdated ? this.statusLastUpdated.toApiJson() : this.statusLastUpdated;
    }
    if (typeof this.dataLastReceived !== 'undefined' && this.dataLastReceived !== null) {
      toReturn['dataLastReceived'] = 'toApiJson' in this.dataLastReceived ? this.dataLastReceived.toApiJson() : this.dataLastReceived;
    }
    return toReturn;
  }
}
class GetConnectionRequest {
  static fromProto(proto) {
    let m = new GetConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = GetConnectionRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class GetConnectionResponse {
  static fromProto(proto) {
    let m = new GetConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.status) {
      m.status = enumStringToValue$3(ConnectionStatus, proto.status);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.context) {
      m.context = enumStringToValue$3(SupportedContexts, proto.context);
    }
    if (proto.statusLastUpdated) {
      m.statusLastUpdated = new Date(proto.statusLastUpdated);
    }
    if (proto.dataLastReceived) {
      m.dataLastReceived = new Date(proto.dataLastReceived);
    }
    if (proto.connectionMessages) {
      m.connectionMessages = proto.connectionMessages.map(ConnectionMessage.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    if (typeof this.statusLastUpdated !== 'undefined' && this.statusLastUpdated !== null) {
      toReturn['statusLastUpdated'] = 'toApiJson' in this.statusLastUpdated ? this.statusLastUpdated.toApiJson() : this.statusLastUpdated;
    }
    if (typeof this.dataLastReceived !== 'undefined' && this.dataLastReceived !== null) {
      toReturn['dataLastReceived'] = 'toApiJson' in this.dataLastReceived ? this.dataLastReceived.toApiJson() : this.dataLastReceived;
    }
    if (typeof this.connectionMessages !== 'undefined' && this.connectionMessages !== null) {
      toReturn['connectionMessages'] = 'toApiJson' in this.connectionMessages ? this.connectionMessages.toApiJson() : this.connectionMessages;
    }
    return toReturn;
  }
}
class GetIntegrationMarketingRequest {
  static fromProto(proto) {
    let m = new GetIntegrationMarketingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetIntegrationRequest {
  static fromProto(proto) {
    let m = new GetIntegrationRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    return toReturn;
  }
}
class GetIntegrationResponse {
  static fromProto(proto) {
    let m = new GetIntegrationResponse();
    m = Object.assign(m, proto);
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$3(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$3(SupportedContexts, v));
    }
    if (proto.preconnectFormFields) {
      m.preconnectFormFields = FormConfig.fromProto(proto.preconnectFormFields);
    }
    if (proto.configPageFields) {
      m.configPageFields = proto.configPageFields.map(FormConfig.fromProto);
    }
    if (proto.instructions) {
      m.instructions = FormConfig.fromProto(proto.instructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.authenticationUrl !== 'undefined') {
      toReturn['authenticationUrl'] = this.authenticationUrl;
    }
    if (typeof this.tokenUrl !== 'undefined') {
      toReturn['tokenUrl'] = this.tokenUrl;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.webhookVerifierToken !== 'undefined') {
      toReturn['webhookVerifierToken'] = this.webhookVerifierToken;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    if (typeof this.fieldExtensionIds !== 'undefined') {
      toReturn['fieldExtensionIds'] = this.fieldExtensionIds;
    }
    if (typeof this.preconnectFormFields !== 'undefined' && this.preconnectFormFields !== null) {
      toReturn['preconnectFormFields'] = 'toApiJson' in this.preconnectFormFields ? this.preconnectFormFields.toApiJson() : this.preconnectFormFields;
    }
    if (typeof this.configPageFields !== 'undefined' && this.configPageFields !== null) {
      toReturn['configPageFields'] = 'toApiJson' in this.configPageFields ? this.configPageFields.toApiJson() : this.configPageFields;
    }
    if (typeof this.instructions !== 'undefined' && this.instructions !== null) {
      toReturn['instructions'] = 'toApiJson' in this.instructions ? this.instructions.toApiJson() : this.instructions;
    }
    return toReturn;
  }
}
class GetMultiIntegrationMarketingRequest {
  static fromProto(proto) {
    let m = new GetMultiIntegrationMarketingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationIds !== 'undefined') {
      toReturn['integrationIds'] = this.integrationIds;
    }
    return toReturn;
  }
}
class GetMultiIntegrationMarketingResponse {
  static fromProto(proto) {
    let m = new GetMultiIntegrationMarketingResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(IntegrationMarketingResponse.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    return toReturn;
  }
}
class HTTPParam {
  static fromProto(proto) {
    let m = new HTTPParam();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class IntegrationMarketingResponse {
  static fromProto(proto) {
    let m = new IntegrationMarketingResponse();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$3(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$3(SupportedContexts, v));
    }
    if (proto.preconnectFormFields) {
      m.preconnectFormFields = FormConfig.fromProto(proto.preconnectFormFields);
    }
    if (proto.configPageFields) {
      m.configPageFields = proto.configPageFields.map(FormConfig.fromProto);
    }
    if (proto.instructions) {
      m.instructions = FormConfig.fromProto(proto.instructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    if (typeof this.preconnectFormFields !== 'undefined' && this.preconnectFormFields !== null) {
      toReturn['preconnectFormFields'] = 'toApiJson' in this.preconnectFormFields ? this.preconnectFormFields.toApiJson() : this.preconnectFormFields;
    }
    if (typeof this.configPageFields !== 'undefined' && this.configPageFields !== null) {
      toReturn['configPageFields'] = 'toApiJson' in this.configPageFields ? this.configPageFields.toApiJson() : this.configPageFields;
    }
    if (typeof this.instructions !== 'undefined' && this.instructions !== null) {
      toReturn['instructions'] = 'toApiJson' in this.instructions ? this.instructions.toApiJson() : this.instructions;
    }
    return toReturn;
  }
}
class IntegrationsFilters {
  static fromProto(proto) {
    let m = new IntegrationsFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    return toReturn;
  }
}
class ListConnectionRequest {
  static fromProto(proto) {
    let m = new ListConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions$1.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListConnectionRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListConnectionResponse {
  static fromProto(proto) {
    let m = new ListConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = proto.connections.map(ConnectionResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata$1.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListIntegrationMarketingRequest {
  static fromProto(proto) {
    let m = new ListIntegrationMarketingRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions$1.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = IntegrationsFilters.fromProto(proto.filters);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = enumStringToValue$3(SupportedContexts, proto.supportedContexts);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    return toReturn;
  }
}
class ListIntegrationMarketingResponse {
  static fromProto(proto) {
    let m = new ListIntegrationMarketingResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(IntegrationMarketingResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata$1.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListIntegrationRequest {
  static fromProto(proto) {
    let m = new ListIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions$1.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = IntegrationsFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListIntegrationResponse {
  static fromProto(proto) {
    let m = new ListIntegrationResponse();
    m = Object.assign(m, proto);
    if (proto.integrations) {
      m.integrations = proto.integrations.map(GetIntegrationResponse.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata$1.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrations !== 'undefined' && this.integrations !== null) {
      toReturn['integrations'] = 'toApiJson' in this.integrations ? this.integrations.toApiJson() : this.integrations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
let PagedRequestOptions$1 = class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
};
let PagedResponseMetadata$1 = class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
};
class ResourceInfo {
  static fromProto(proto) {
    let m = new ResourceInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.resourceName !== 'undefined') {
      toReturn['resourceName'] = this.resourceName;
    }
    if (typeof this.resourceUrl !== 'undefined') {
      toReturn['resourceUrl'] = this.resourceUrl;
    }
    return toReturn;
  }
}
class UpdateConnectionRequest {
  static fromProto(proto) {
    let m = new UpdateConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.updateFields) {
      m.updateFields = UpdateConnectionRequestUpdateFields.fromProto(proto.updateFields);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.updateFields !== 'undefined' && this.updateFields !== null) {
      toReturn['updateFields'] = 'toApiJson' in this.updateFields ? this.updateFields.toApiJson() : this.updateFields;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdateConnectionRequestUpdateFields {
  static fromProto(proto) {
    let m = new UpdateConnectionRequestUpdateFields();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue$3(ConnectionStatus, proto.status);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomFields.fromProto);
    }
    if (proto.context) {
      m.context = enumStringToValue$3(SupportedContexts, proto.context);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.context !== 'undefined') {
      toReturn['context'] = this.context;
    }
    return toReturn;
  }
}
class UpdateIntegrationRequestUpdateFields {
  static fromProto(proto) {
    let m = new UpdateIntegrationRequestUpdateFields();
    m = Object.assign(m, proto);
    if (proto.connectionMethod) {
      m.connectionMethod = enumStringToValue$3(ConnectionMethods, proto.connectionMethod);
    }
    if (proto.additionalInfo) {
      m.additionalInfo = AdditionalInfo.fromProto(proto.additionalInfo);
    }
    if (proto.maxConnections) {
      m.maxConnections = parseInt(proto.maxConnections, 10);
    }
    if (proto.supportedContexts) {
      m.supportedContexts = proto.supportedContexts.map(v => enumStringToValue$3(SupportedContexts, v));
    }
    if (proto.preconnectFormFields) {
      m.preconnectFormFields = FormConfig.fromProto(proto.preconnectFormFields);
    }
    if (proto.configPageFields) {
      m.configPageFields = proto.configPageFields.map(FormConfig.fromProto);
    }
    if (proto.instructions) {
      m.instructions = FormConfig.fromProto(proto.instructions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.logo !== 'undefined') {
      toReturn['logo'] = this.logo;
    }
    if (typeof this.displayName !== 'undefined') {
      toReturn['displayName'] = this.displayName;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.integrationType !== 'undefined') {
      toReturn['integrationType'] = this.integrationType;
    }
    if (typeof this.clientId !== 'undefined') {
      toReturn['clientId'] = this.clientId;
    }
    if (typeof this.clientSecret !== 'undefined') {
      toReturn['clientSecret'] = this.clientSecret;
    }
    if (typeof this.apiKey !== 'undefined') {
      toReturn['apiKey'] = this.apiKey;
    }
    if (typeof this.connectionMethod !== 'undefined') {
      toReturn['connectionMethod'] = this.connectionMethod;
    }
    if (typeof this.authenticationUrl !== 'undefined') {
      toReturn['authenticationUrl'] = this.authenticationUrl;
    }
    if (typeof this.tokenUrl !== 'undefined') {
      toReturn['tokenUrl'] = this.tokenUrl;
    }
    if (typeof this.longDescription !== 'undefined') {
      toReturn['longDescription'] = this.longDescription;
    }
    if (typeof this.additionalInfo !== 'undefined' && this.additionalInfo !== null) {
      toReturn['additionalInfo'] = 'toApiJson' in this.additionalInfo ? this.additionalInfo.toApiJson() : this.additionalInfo;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    if (typeof this.maxConnections !== 'undefined') {
      toReturn['maxConnections'] = this.maxConnections;
    }
    if (typeof this.webhookVerifierToken !== 'undefined') {
      toReturn['webhookVerifierToken'] = this.webhookVerifierToken;
    }
    if (typeof this.supportedContexts !== 'undefined') {
      toReturn['supportedContexts'] = this.supportedContexts;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.fieldExtensionIds !== 'undefined') {
      toReturn['fieldExtensionIds'] = this.fieldExtensionIds;
    }
    if (typeof this.preconnectFormFields !== 'undefined' && this.preconnectFormFields !== null) {
      toReturn['preconnectFormFields'] = 'toApiJson' in this.preconnectFormFields ? this.preconnectFormFields.toApiJson() : this.preconnectFormFields;
    }
    if (typeof this.configPageFields !== 'undefined' && this.configPageFields !== null) {
      toReturn['configPageFields'] = 'toApiJson' in this.configPageFields ? this.configPageFields.toApiJson() : this.configPageFields;
    }
    if (typeof this.instructions !== 'undefined' && this.instructions !== null) {
      toReturn['instructions'] = 'toApiJson' in this.instructions ? this.instructions.toApiJson() : this.instructions;
    }
    return toReturn;
  }
}
class UpdateIntegrationRequest {
  static fromProto(proto) {
    let m = new UpdateIntegrationRequest();
    m = Object.assign(m, proto);
    if (proto.updateFields) {
      m.updateFields = UpdateIntegrationRequestUpdateFields.fromProto(proto.updateFields);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.updateFields !== 'undefined' && this.updateFields !== null) {
      toReturn['updateFields'] = 'toApiJson' in this.updateFields ? this.updateFields.toApiJson() : this.updateFields;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class WebsiteInfo {
  static fromProto(proto) {
    let m = new WebsiteInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.siteName !== 'undefined') {
      toReturn['siteName'] = this.siteName;
    }
    if (typeof this.siteUrl !== 'undefined') {
      toReturn['siteUrl'] = this.siteUrl;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class GetAuthorizationCodeRedirectURLRequest {
  static fromProto(proto) {
    let m = new GetAuthorizationCodeRedirectURLRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.baseUrl !== 'undefined') {
      toReturn['baseUrl'] = this.baseUrl;
    }
    return toReturn;
  }
}
class GetAuthorizationCodeRedirectURLResponse {
  static fromProto(proto) {
    let m = new GetAuthorizationCodeRedirectURLResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    return toReturn;
  }
}
class RevokeAccessTokenAndDeleteRequest {
  static fromProto(proto) {
    let m = new RevokeAccessTokenAndDeleteRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListVendorConnectionRequestFilters {
  static fromProto(proto) {
    let m = new ListVendorConnectionRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.integrationIds !== 'undefined') {
      toReturn['integrationIds'] = this.integrationIds;
    }
    return toReturn;
  }
}
class GetBusinessDataRequest {
  static fromProto(proto) {
    let m = new GetBusinessDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    return toReturn;
  }
}
class GetBusinessDataResponse {
  static fromProto(proto) {
    let m = new GetBusinessDataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.regionCode !== 'undefined') {
      toReturn['regionCode'] = this.regionCode;
    }
    if (typeof this.stateCode !== 'undefined') {
      toReturn['stateCode'] = this.stateCode;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    return toReturn;
  }
}
class GetMultiVendorConnectionRequest {
  static fromProto(proto) {
    let m = new GetMultiVendorConnectionRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionIds !== 'undefined') {
      toReturn['connectionIds'] = this.connectionIds;
    }
    return toReturn;
  }
}
class GetMultiVendorConnectionResponse {
  static fromProto(proto) {
    let m = new GetMultiVendorConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = proto.connections.map(VendorConnection.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    return toReturn;
  }
}
class GetVendorConnectionRequest {
  static fromProto(proto) {
    let m = new GetVendorConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.options) {
      m.options = GetVendorConnectionRequestOptions.fromProto(proto.options);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.options !== 'undefined' && this.options !== null) {
      toReturn['options'] = 'toApiJson' in this.options ? this.options.toApiJson() : this.options;
    }
    return toReturn;
  }
}
class GetVendorConnectionResponse {
  static fromProto(proto) {
    let m = new GetVendorConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = VendorConnection.fromProto(proto.connection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    return toReturn;
  }
}
class ListVendorConnectionRequest {
  static fromProto(proto) {
    let m = new ListVendorConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListVendorConnectionRequestFilters.fromProto(proto.filters);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListVendorConnectionResponse {
  static fromProto(proto) {
    let m = new ListVendorConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connections) {
      m.connections = proto.connections.map(VendorConnection.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connections !== 'undefined' && this.connections !== null) {
      toReturn['connections'] = 'toApiJson' in this.connections ? this.connections.toApiJson() : this.connections;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class GetVendorConnectionRequestOptions {
  static fromProto(proto) {
    let m = new GetVendorConnectionRequestOptions();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    return toReturn;
  }
}
class UpdateVendorConnectionRequest {
  static fromProto(proto) {
    let m = new UpdateVendorConnectionRequest();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = VendorConnection.fromProto(proto.connection);
    }
    if (proto.updateMask) {
      m.updateMask = FieldMask.fromProto(proto.updateMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    if (typeof this.updateMask !== 'undefined' && this.updateMask !== null) {
      toReturn['updateMask'] = 'toApiJson' in this.updateMask ? this.updateMask.toApiJson() : this.updateMask;
    }
    return toReturn;
  }
}
class UpdateVendorConnectionResponse {
  static fromProto(proto) {
    let m = new UpdateVendorConnectionResponse();
    m = Object.assign(m, proto);
    if (proto.connection) {
      m.connection = VendorConnection.fromProto(proto.connection);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.connection !== 'undefined' && this.connection !== null) {
      toReturn['connection'] = 'toApiJson' in this.connection ? this.connection.toApiJson() : this.connection;
    }
    return toReturn;
  }
}
class VendorConnection {
  static fromProto(proto) {
    let m = new VendorConnection();
    m = Object.assign(m, proto);
    if (proto.status) {
      m.status = enumStringToValue(ConnectionStatus, proto.status);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.integrationId !== 'undefined') {
      toReturn['integrationId'] = this.integrationId;
    }
    if (typeof this.connectionId !== 'undefined') {
      toReturn['connectionId'] = this.connectionId;
    }
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.userId !== 'undefined') {
      toReturn['userId'] = this.userId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.customFields !== 'undefined') {
      toReturn['customFields'] = this.customFields;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ConnectionsApiService = /*#__PURE__*/(() => {
  class ConnectionsApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateConnectionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListConnectionResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getConnectionData(r) {
      const request = r.toApiJson ? r : new GetConnectionDataRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ConnectionsService/GetConnectionData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetConnectionDataResponse.fromProto(resp)));
    }
  }
  ConnectionsApiService.ɵfac = function ConnectionsApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ConnectionsApiService)();
  };
  ConnectionsApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConnectionsApiService,
    factory: ConnectionsApiService.ɵfac,
    providedIn: 'root'
  });
  return ConnectionsApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationManagementApiService = /*#__PURE__*/(() => {
  class IntegrationManagementApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateIntegrationResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListIntegrationResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    get(r) {
      const request = r.toApiJson ? r : new GetIntegrationRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetIntegrationResponse.fromProto(resp)));
    }
    emitEvent(r) {
      const request = r.toApiJson ? r : new EmitEventRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationManagementService/EmitEvent", request.toApiJson(), this.apiOptions()).pipe(map(resp => EmitEventResponse.fromProto(resp)));
    }
  }
  IntegrationManagementApiService.ɵfac = function IntegrationManagementApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationManagementApiService)();
  };
  IntegrationManagementApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationManagementApiService,
    factory: IntegrationManagementApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationManagementApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let IntegrationMarketingApiService = /*#__PURE__*/(() => {
  class IntegrationMarketingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    list(r) {
      const request = r.toApiJson ? r : new ListIntegrationMarketingRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationMarketingService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListIntegrationMarketingResponse.fromProto(resp)));
    }
    get(r) {
      const request = r.toApiJson ? r : new GetIntegrationMarketingRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationMarketingService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => IntegrationMarketingResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiIntegrationMarketingRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.IntegrationMarketingService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiIntegrationMarketingResponse.fromProto(resp)));
    }
  }
  IntegrationMarketingApiService.ɵfac = function IntegrationMarketingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || IntegrationMarketingApiService)();
  };
  IntegrationMarketingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: IntegrationMarketingApiService,
    factory: IntegrationMarketingApiService.ɵfac,
    providedIn: 'root'
  });
  return IntegrationMarketingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let OAuthApiService = /*#__PURE__*/(() => {
  class OAuthApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAuthorizationCodeRedirectUrl(r) {
      const request = r.toApiJson ? r : new GetAuthorizationCodeRedirectURLRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.OAuthService/GetAuthorizationCodeRedirectURL", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuthorizationCodeRedirectURLResponse.fromProto(resp)));
    }
    revokeAccessTokenAndDelete(r) {
      const request = r.toApiJson ? r : new RevokeAccessTokenAndDeleteRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.OAuthService/RevokeAccessTokenAndDelete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  OAuthApiService.ɵfac = function OAuthApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || OAuthApiService)();
  };
  OAuthApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: OAuthApiService,
    factory: OAuthApiService.ɵfac,
    providedIn: 'root'
  });
  return OAuthApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProxyApiService = /*#__PURE__*/(() => {
  class ProxyApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    callIntegrationEndpoint(r) {
      const request = r.toApiJson ? r : new CallIntegrationEndpointRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ProxyService/CallIntegrationEndpoint", request.toApiJson(), this.apiOptions()).pipe(map(resp => CallIntegrationEndpointResponse.fromProto(resp)));
    }
    callVendastaEndpoint(r) {
      const request = r.toApiJson ? r : new CallVendastaEndpointRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.ProxyService/CallVendastaEndpoint", request.toApiJson(), this.apiOptions()).pipe(map(resp => CallVendastaEndpointResponse.fromProto(resp)));
    }
  }
  ProxyApiService.ɵfac = function ProxyApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProxyApiService)();
  };
  ProxyApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProxyApiService,
    factory: ProxyApiService.ɵfac,
    providedIn: 'root'
  });
  return ProxyApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let VendorConnectionApiService = /*#__PURE__*/(() => {
  class VendorConnectionApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    get(r) {
      const request = r.toApiJson ? r : new GetVendorConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.VendorConnectionService/Get", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetVendorConnectionResponse.fromProto(resp)));
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiVendorConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.VendorConnectionService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiVendorConnectionResponse.fromProto(resp)));
    }
    list(r) {
      const request = r.toApiJson ? r : new ListVendorConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.VendorConnectionService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListVendorConnectionResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateVendorConnectionRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.VendorConnectionService/Update", request.toApiJson(), this.apiOptions()).pipe(map(resp => UpdateVendorConnectionResponse.fromProto(resp)));
    }
    getBusinessData(r) {
      const request = r.toApiJson ? r : new GetBusinessDataRequest(r);
      return this.http.post(this._host + "/platform_integrations.v1.VendorConnectionService/GetBusinessData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessDataResponse.fromProto(resp)));
    }
  }
  VendorConnectionApiService.ɵfac = function VendorConnectionApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || VendorConnectionApiService)();
  };
  VendorConnectionApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: VendorConnectionApiService,
    factory: VendorConnectionApiService.ɵfac,
    providedIn: 'root'
  });
  return VendorConnectionApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { APIRequest, APIResponse, Access, ActionType, Actions, AdditionalInfo, CallIntegrationEndpointRequest, CallIntegrationEndpointResponse, CallVendastaEndpointRequest, CallVendastaEndpointResponse, ConnectionIdentifier, ConnectionMessage, ConnectionMethods, ConnectionResponse, ConnectionStatus, ConnectionsApiService, CreateConnectionRequest, CreateConnectionResponse, CreateIntegrationRequest, CreateIntegrationResponse, CustomFields, DeleteConnectionRequest, DeleteIntegrationRequest, EmitEventRequest, EmitEventResponse, FieldConfig, FieldMask, FieldOptions, FieldScope, FieldType, FormConfig, GetAuthorizationCodeRedirectURLRequest, GetAuthorizationCodeRedirectURLResponse, GetBusinessDataRequest, GetBusinessDataResponse, GetConnectionDataRequest, GetConnectionDataResponse, GetConnectionRequest, GetConnectionRequestFilters, GetConnectionResponse, GetIntegrationMarketingRequest, GetIntegrationRequest, GetIntegrationResponse, GetMultiIntegrationMarketingRequest, GetMultiIntegrationMarketingResponse, GetMultiVendorConnectionRequest, GetMultiVendorConnectionResponse, GetVendorConnectionRequest, GetVendorConnectionRequestOptions, GetVendorConnectionResponse, HTTPMethod, HTTPParam, HostService, IntegrationManagementApiService, IntegrationMarketingApiService, IntegrationMarketingResponse, IntegrationsFilters, ListConnectionRequest, ListConnectionRequestFilters, ListConnectionResponse, ListIntegrationMarketingRequest, ListIntegrationMarketingResponse, ListIntegrationRequest, ListIntegrationResponse, ListVendorConnectionRequest, ListVendorConnectionRequestFilters, ListVendorConnectionResponse, OAuthApiService, PagedRequestOptions, PagedResponseMetadata, ProxyApiService, ResourceInfo, RevokeAccessTokenAndDeleteRequest, Severity, SupportedContexts, UpdateConnectionRequest, UpdateConnectionRequestUpdateFields, UpdateIntegrationRequest, UpdateIntegrationRequestUpdateFields, UpdateVendorConnectionRequest, UpdateVendorConnectionResponse, VendorConnection, VendorConnectionApiService, WebsiteInfo };
